import { useCallback, useEffect, useState } from "react";
import Fuse from "fuse.js";
import moment from "moment";
import { PropagateLoader } from "react-spinners";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import Card from "../atoms/Card";
import CardHeader from "../atoms/CardHeader";
import IconButton from "../atoms/IconButton";
import QyRAllTable from "../organisms/qyr/QyRAllTable";
import QyRAllFilter from "../organisms/qyr/QyRAllFilter";
import { GET_INMUEBLES } from "../../api/apiInmuebles";
import { GET_QUEJAS_REPORTES_ALL } from "../../api/apiQuejas";
import { exportQuejasToExcel } from "../../utils/excel/ExportQuejasToExcel";
import Breadcrumb from "../molecules/Breadcrumb";

const QyRTemplate = () => {
    const [loading, setLoading] = useState();
    const [inmuebles, setInmuebles] = useState();
    const [quejasReportes, setQuejasReportes] = useState();
    const [filteredQuejasReportes, setFilteredQuejasReportes] = useState();
    const [filters, setFilters] = useState({
        description: "",
        incidentRange: { start: "", end: "" },
        serviceRange: { start: "", end: "" },
        status: "",
        inmuebles: [],
    });

    useEffect(() => {
        const getInmuebles = async () => {
            try {
                const inmueblesData = await GET_INMUEBLES();
                setInmuebles(inmueblesData);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        }

        getInmuebles();
    }, []);

    const getQuejas_Reportes = useCallback ( async () => {
        setLoading(true);
        try {
            const quejasReportesData = await GET_QUEJAS_REPORTES_ALL();
            setQuejasReportes(quejasReportesData);
            setFilteredQuejasReportes(quejasReportesData);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        getQuejas_Reportes();
    }, [getQuejas_Reportes]);

    useEffect(() => {
        if (!quejasReportes) return;

        let result = [...quejasReportes];

        if (filters.description) {
            const fuse = new Fuse(result, {
                keys: ["description"],
                threshold: 0.3,
            });
            result = fuse.search(filters.description).map(res => res.item);
        }

        if (filters.incidentRange.start && filters.incidentRange.end) {
            result = result.filter(qr => {
                const date = moment(qr.incident_date);
                return (
                    date.isSameOrAfter(moment(filters.incidentRange.start)) &&
                    date.isSameOrBefore(moment(filters.incidentRange.end))
                );
            });
        }

        if (filters.serviceRange.start && filters.serviceRange.end) {
            result = result.filter(qr => {
                const date = moment(qr.service_date);
                return (
                    date.isSameOrAfter(moment(filters.serviceRange.start)) &&
                    date.isSameOrBefore(moment(filters.serviceRange.end))
                );
            });
        }

        if (filters.status) {
            if (filters.status === "Pendiente") {
                result = result.filter(qr => !qr.service_date);
            } else if (filters.status === "Resuelto") {
                result = result.filter(qr => qr.service_date);
            }
        }

        if (filters.inmuebles && filters.inmuebles.length > 0) {
            result = result.filter(qr =>
                filters.inmuebles.includes(qr.propertieId)
            );
        }

        setFilteredQuejasReportes(result);
    }, [filters, quejasReportes]);

    if (loading) return <div className="h-full w-full flex justify-center items-center"> <PropagateLoader color="red" /> </div>

    return (
        <div className="flex flex-col gap-4">
            <CardHeader
                left={
                    <Breadcrumb
                        items={[
                            { label: "Inicio", to: "/inicio" },
                            { label: "Quejas y reportes", to: null },
                        ]}
                    />
                }
                right={
                    <IconButton
                        icon={PiMicrosoftExcelLogoFill}
                        bgColor="bg-green-600" iconColor="text-white"
                        onClick={() => exportQuejasToExcel(filteredQuejasReportes, inmuebles)}
                    />
                }
            />
            <Card>
                <QyRAllFilter filters={filters} setFilters={setFilters} inmuebles={inmuebles} />
                <QyRAllTable data={filteredQuejasReportes} refetch={getQuejas_Reportes} loading={loading} inmuebles={inmuebles} />
            </Card>
        </div>
    );
};

export default QyRTemplate;